<template>
  <li class="category-item" :class="`level-${item.level}`" ref="categoryItemRef">
    <a
      href="#"
      class="category-link"
      @click.prevent="scrollIntoSection(item.id)"
      :class="{
        active: activeId === item.id,
        'ml-[26px]': !item.children.length && !noDropdown,
      }"
    >
      <IconDropdown
        class="text-[18px] text-[var(--x-text-3)] transition-all shrink-0 mt-[5px]"
        :class="{ '-rotate-90': !isExpanded }"
        v-if="item.children.length"
        @click.stop="toggleExpanded"
      />
      {{ item.name }}
    </a>

    <!-- 如果有子目录，递归渲染自己 -->
    <ul
      v-if="item.children && item.children.length"
      class="category-sub-list"
      :class="{ collapsed: !isExpanded }"
    >
      <CategoryItem
        v-for="subItem in item.children"
        :key="subItem.id"
        :item="subItem"
        :active-id="activeId"
        :scroll-into-section="scrollIntoSection"
      />
    </ul>
  </li>
</template>
<script setup lang="ts">
import IconDropdown from '~/assets/svg/icon-dropdown.svg?component';
import type { ICategoryItem } from '../types'; // 你定义的类型文件

interface Props {
  item: ICategoryItem;
  activeId?: string;
  scrollIntoSection: (id: string) => void;
  defaultExpanded?: boolean;
  noDropdown?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  defaultExpanded: true,
  noDropdown: false,
});

// 控制展开/折叠状态
const isExpanded = ref(props.defaultExpanded);
// 获取当前目录项的引用
const categoryItemRef = ref<HTMLElement>();

// 切换展开/折叠状态
const toggleExpanded = () => {
  isExpanded.value = !isExpanded.value;
};
// 监听 activeId 变化，当匹配当前项时滚动到视口
watch(
  () => props.activeId,
  newActiveId => {
    if (newActiveId === props.item.id && categoryItemRef.value) {
      // 使用 scrollIntoView 滚动到视口
      categoryItemRef.value.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'nearest',
      });
    }
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
.category-list {
  @apply p-0 m-0 list-none overflow-y-auto;

  .category-item {
    .category-link {
      @apply flex items-start gap-2  text-[16px]  mb-4 text-[var(--x-text-3)] leading-7 no-underline transition-colors;
      font-weight: 400;

      &:hover {
        @apply text-[var(--x-purple-7)];
        font-weight: var(--x-weight-medium, 600);
      }
      // 激活状态样式
      &.active {
        @apply text-[var(--x-purple-7)];
        font-weight: var(--x-weight-medium, 600);
      }
    }

    &.level-0 {
      .category-link {
        @apply font-medium;
      }
    }
  }
  .category-sub-list {
    @apply transition-all duration-300 ease-in-out overflow-hidden;
    max-height: 600px;
    padding-left: 26px;

    &.collapsed {
      @apply max-h-0;
    }
  }
}
</style>
